import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    FormDataConsumer,
    FormDataConsumerRenderParams
} from 'react-admin';
import { NokEmailTemplateCodeEditor } from "../code-editor/NokEmailTemplateCodeEditor";
import { JSX, ReactElement } from "react";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";
import { NokEmailTemplateTargetInputs } from "../edit/components/Noks/NokEmailTemplateTargetInputs";

export const NokEmailTemplateCreate: () => JSX.Element = (): JSX.Element => {

    const types: { id: string, name: string }[] = [
        { id: 'email_wrapper', name: 'Email Wrapper' },
        { id: 'ms_email_body', name: 'Mystery Shopper Message Body' },
        { id: 'ms_form_message', name: 'Mystery Shopper Form Message' },
        { id: 'cs_email_body', name: 'Compliance Sniffer Message Body' },
        { id: 'cs_form_message', name: 'Compliance Sniffer Form Message' },
    ];

    return (
        <Create>
            <SimpleForm >
                <TextInput source="name" validate={[required()]} />
                <SelectInput source="type" choices={ types } validate={ [required()] } />
                <NokEmailTemplateTargetInputs />
                <FormDataConsumer<{ type: string }>>
                    {({
                          formData,
                          scopedFormData,
                          ...rest
                      }: FormDataConsumerRenderParams<{ type: string }>): ReactElement => {
                        if (formData?.type?.toLowerCase().includes('form')) {
                            return (
                                <TextInput source="html" validate={[required()]} multiline rows={ 15 } />
                            );
                        }
                        return (
                            <NokEmailTemplateCodeEditor  />
                        );
                    } }
                </FormDataConsumer>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
